import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingBag, Search, Menu, X, ChevronDown } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { categories } from '../data/categories';
export function Header() {
  const {
    itemCount,
    dispatch
  } = useCart();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCategoriesOpen, setIsCategoriesOpen] = useState(false);
  const navigate = useNavigate();
  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const query = formData.get('q');
    if (query) {
      navigate(`/shop?q=${query}`);
      setIsMobileMenuOpen(false);
    }
  };
  return <header className="sticky top-0 z-40 w-full bg-white border-b border-gray-200" data-id="element-139">
      {/* Announcement Bar */}
      <div className="bg-gray-900 text-white text-xs py-2 text-center px-4" data-id="element-140">
        Free shipping on orders over MVR 500 &bull; Pay securely with Bank of
        Maldives
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="flex justify-between items-center h-16" data-id="element-142">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-143">
            <Link to="/" className="flex items-center gap-2" data-id="element-144">
              <div className="w-8 h-8 rounded bg-red-100 flex items-center justify-center text-red-600 font-bold text-xl" data-id="element-145">
                B
              </div>
              <span className="font-bold text-xl text-gray-900 tracking-tight" data-id="element-146">
                Beach Shop
              </span>
            </Link>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8" data-id="element-147">
            <Link to="/shop" className="text-gray-600 hover:text-gray-900 font-medium text-sm" data-id="element-148">
              Shop All
            </Link>

            <div className="relative group" onMouseEnter={() => setIsCategoriesOpen(true)} onMouseLeave={() => setIsCategoriesOpen(false)} data-id="element-149">
              <button className="flex items-center text-gray-600 hover:text-gray-900 font-medium text-sm gap-1" data-id="element-150">
                Categories <ChevronDown className="w-4 h-4" data-id="element-151" />
              </button>

              {isCategoriesOpen && <div className="absolute top-full left-0 w-48 pt-2" data-id="element-152">
                  <div className="bg-white rounded-lg shadow-lg border border-gray-100 py-2" data-id="element-153">
                    {categories.map(cat => <Link key={cat.id} to={`/shop/${cat.id}`} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 hover:text-red-600" onClick={() => setIsCategoriesOpen(false)} data-id="element-154">
                        {cat.name}
                      </Link>)}
                  </div>
                </div>}
            </div>

            <Link to="/about" className="text-gray-600 hover:text-gray-900 font-medium text-sm" data-id="element-155">
              About
            </Link>
            <Link to="/contact" className="text-gray-600 hover:text-gray-900 font-medium text-sm" data-id="element-156">
              Contact
            </Link>
          </nav>

          {/* Right Icons */}
          <div className="flex items-center gap-4" data-id="element-157">
            <form onSubmit={handleSearch} className="hidden lg:flex relative" data-id="element-158">
              <input type="text" name="q" placeholder="Search products..." className="pl-9 pr-4 py-1.5 text-sm border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent w-48 transition-all focus:w-64" data-id="element-159" />
              <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-160" />
            </form>

            <button className="lg:hidden text-gray-600 hover:text-gray-900" data-id="element-161">
              <Search className="w-5 h-5" data-id="element-162" />
            </button>

            <button className="relative text-gray-600 hover:text-gray-900 p-1" onClick={() => dispatch({
            type: 'TOGGLE_CART',
            payload: true
          })} aria-label="Open cart" data-id="element-163">
              <ShoppingBag className="w-6 h-6" data-id="element-164" />
              {itemCount > 0 && <span className="absolute top-0 right-0 -mt-1 -mr-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-600 text-[10px] font-bold text-white" data-id="element-165">
                  {itemCount}
                </span>}
            </button>

            <button className="md:hidden text-gray-600 hover:text-gray-900 ml-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-166">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-167" /> : <Menu className="w-6 h-6" data-id="element-168" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden border-t border-gray-200 bg-white px-4 pt-2 pb-4 space-y-1" data-id="element-169">
          <form onSubmit={handleSearch} className="mb-4 relative mt-2" data-id="element-170">
            <input type="text" name="q" placeholder="Search products..." className="w-full pl-9 pr-4 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500" data-id="element-171" />
            <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" data-id="element-172" />
          </form>

          <Link to="/shop" className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-173">
            Shop All
          </Link>

          <div className="px-3 py-2 text-sm font-semibold text-gray-500 uppercase tracking-wider" data-id="element-174">
            Categories
          </div>
          {categories.map(cat => <Link key={cat.id} to={`/shop/${cat.id}`} className="block pl-6 pr-3 py-2 rounded-md text-base font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900" onClick={() => setIsMobileMenuOpen(false)} data-id="element-175">
              {cat.name}
            </Link>)}

          <Link to="/about" className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50 mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-176">
            About
          </Link>
          <Link to="/contact" className="block px-3 py-2 rounded-md text-base font-medium text-gray-900 hover:bg-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-177">
            Contact
          </Link>
        </div>}
    </header>;
}